module.exports = __webpack_public_path__ + "img/93.3.TP.f2b7c49f.png";